var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAboutIconRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 10.7999H21.1V8.3999H18.7V10.7999ZM19.9 23.9999C14.608 23.9999 10.3 19.6919 10.3 14.3999C10.3 9.1079 14.608 4.7999 19.9 4.7999C25.192 4.7999 29.5 9.1079 29.5 14.3999C29.5 19.6919 25.192 23.9999 19.9 23.9999ZM19.9 2.3999C18.3242 2.3999 16.7637 2.71029 15.3078 3.31335C13.8519 3.9164 12.529 4.80032 11.4147 5.91462C9.16431 8.16506 7.90002 11.2173 7.90002 14.3999C7.90002 17.5825 9.16431 20.6347 11.4147 22.8852C12.529 23.9995 13.8519 24.8834 15.3078 25.4865C16.7637 26.0895 18.3242 26.3999 19.9 26.3999C23.0826 26.3999 26.1349 25.1356 28.3853 22.8852C30.6357 20.6347 31.9 17.5825 31.9 14.3999C31.9 12.824 31.5896 11.2636 30.9866 9.8077C30.3835 8.35179 29.4996 7.02892 28.3853 5.91462C27.271 4.80032 25.9481 3.9164 24.4922 3.31335C23.0363 2.71029 21.4759 2.3999 19.9 2.3999V2.3999ZM18.7 20.3999H21.1V13.1999H18.7V20.3999Z",
    fill: "#c30019"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAboutIconRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/about_icon_red.d5c987aa458bd34d4192fd2093780334.svg";